export enum EligibilityField {
  DEPENDENT_HEADER = 'dependentHeader',
  ELIGIBILITY_TYPE = 'eligibilityType',
  ELIGIBILITY_ERROR_BANNER = 'eligibilityErrorBanner',
  EMPLOYEE_FULL_NAME = 'employeeFullName',
  EMPLOYEE_FIRST_NAME = 'employeeFirstName',
  EMPLOYEE_LAST_NAME = 'employeeLastName',
  EMPLOYEE_DATE_OF_BIRTH = 'employeeDOB',
  DEPENDENT_INELIGIBLE = 'eligibilityDependentIneligible',
  DEPENDENT_EMPLOYEE_RELATIONSHIP = 'dependentTypeId',
  RELATIONSHIP_INFO = 'relationshipInfo',
  CUSTOMER_CODE_FIELD_NAME = 'customerCode',
  EMPLOYEE_CUSTOMER_CODE_FIELD_NAME = 'employeeCustomerCodeField',
  DEPENDENT_CUSTOMER_CODE_FIELD_NAME = 'dependentCustomerCodeField',
  EMPLOYEE_INFORMATION = 'employeeInformation',
}

/**
 * Type for the value of LD flag requireEligibilityConfirmation
 */
export interface RequireEligibilityConfirmationLDFlag {
  isEnabled?: boolean // true to require ineligible user to confirm eligibility upon logging in
  skipIneligibleUserWithLyraCode?: boolean // true to skip eligibility confirmation for ineligible users assigned with lyra code
}

export enum EapHpiNotificationType {
  ADD_HEALTH_PLAN = 'add_health_plan',
  ADD_PAYMENT_INFO = 'add_payment_info',
  VIEW_COST_ESTIMATE = 'view_cost_estimate',
}

export type EapToHpiBannerStateResponse = {
  expirationDate: string
  flowAs: string
  notificationType: EapHpiNotificationType
  providerLyraId: string
  sessionType: string
  sessionsRemaining: number

  // Optional fields related to dependents
  childLyraId?: string
  dependentName?: string

  // Optional field for dual entitlement - if set, indicates program type for the session limit being hit
  sessionProgramType?: 'therapy' | 'coaching'
}

export type EapToHpiBannerState = Omit<EapToHpiBannerStateResponse, 'sessionsRemaining'> & { sessionsRemaining: 1 | 0 }

// Helper to just create an empty object for the hook
type Undefinified<T> = {
  [K in keyof T]: undefined
}

export type EapToHpiBannerNotLoaded = {
  isEapHpiBannerStateLoaded: false
  isHomebaseBannerVisible: false
  isAccountBannerVisible: false
} & Undefinified<EapToHpiBannerState>

export type EapToHpiBannerLoaded = {
  isEapHpiBannerStateLoaded: true
  isHomebaseBannerVisible: boolean
  isAccountBannerVisible: boolean
} & (EapToHpiBannerState | Undefinified<EapToHpiBannerState>)

export type EapToHpiHomebaseBannerVisible = {
  isEapHpiBannerStateLoaded: true
  isHomebaseBannerVisible: true
  isAccountBannerVisible: boolean
} & EapToHpiBannerState

export type EapToHpiAccountBannerVisible = {
  isEapHpiBannerStateLoaded: true
  isHomebaseBannerVisible: boolean
  isAccountBannerVisible: true
} & EapToHpiBannerState

export type EapToHpiBannerStatus =
  | EapToHpiBannerNotLoaded
  | EapToHpiBannerLoaded
  | EapToHpiHomebaseBannerVisible
  | EapToHpiAccountBannerVisible
